export default __webpack_public_path__ + "static/media/Refresh-Professional-Painting-Service4.82de54d7.png";